import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  geoDetector,
  fetchAndCacheGeoLanguage,
} from './geoLanguageDetector';

const environment = import.meta.env.VITE_APP_ENV;

const languageDetector = new LanguageDetector();
languageDetector.addDetector(geoDetector);

i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: environment === 'develop',
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'geo', 'sessionStorage', 'navigator', 'htmlTag'],
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    if (typeof window === 'undefined') return;
    // First visit: no geo cache yet — fetch, cache, and apply
    if (!localStorage.getItem('i18n_geo_lng')) {
      fetchAndCacheGeoLanguage().then((geoLang) => {
        if (geoLang && geoLang !== i18n.language) {
          i18n.changeLanguage(geoLang);
        }
      });
    }
  });

export default i18n;
